class DataStorage {
    private storage: WeakMap<any, any>;

    constructor() {
        this.storage = new WeakMap();
    }

    put(element: any, key: any, obj: any) {
        if (!this.storage.has(element)) {
            this.storage.set(element, new Map());
        }
        this.storage.get(element).set(key, obj);
    }

    get(element: any, key: any) {
        return this.storage.get(element).get(key);
    }

    has(element: any, key: any) {
        return this.storage.has(element) && this.storage.get(element).has(key);
    }

    remove(element: any, key: any) {
        const ret = this.storage.get(element).delete(key);
        if (this.storage.get(element).size !== 0) {
            this.storage.delete(element);
        }
        return ret;
    }
}

export default new DataStorage();
